<template>
    <ContainerContent
        class="mb-16"
        max-class="max-w-md-ceil"
        outer-container
    >
        <v-row>
            <v-col>
                <h1 class="page-title">Cart</h1>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <CartMain></CartMain>
            </v-col>
        </v-row>
    </ContainerContent>
</template>

<script lang="ts" setup>
    import CartMain from '~/components/cart/CartMain/CartMain.vue';
    import {
        CartSecretCodesKey,
        cartSecretCodes
    } from '~/composables';
    import type { CartSecretCodes } from '~/types';
    import ContainerContent from '~/components/ContainerContent/ContainerContent.vue';

    definePageMeta({
        scrollToTop: true
    });

    const $config = useRuntimeConfig();
    const brandTitle = $config.public.brand.title as string;

    useHead({
        title: `Cart | ${brandTitle}`,
        meta: [
            {
                name: 'description',
                content: 'Cart'
            }
        ]
    });

    provide<CartSecretCodes>(CartSecretCodesKey, cartSecretCodes);
</script>

<style lang="scss" scoped></style>
